import { useQuery } from "@tanstack/react-query";
import { devicesApi } from "@/api/devices";

export function useDevices() {
  return useQuery({
    queryKey: ["devices"],
    queryFn: () => devicesApi.list(),
    refetchInterval: 30_000,
  });
}
